var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _path18, _path19, _rect, _path20, _circle2, _path21, _polygon, _path22, _polygon2, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 782.14519,
    height: 522.41797,
    viewBox: "0 0 782.14519 522.41797",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.9274,415.33663c0-67.16541,54.44833-226.54561,121.61374-226.54561s121.61374,159.3802,121.61374,226.54561a121.61374,121.61374,0,0,1-243.22748,0Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3aaa35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330.5411,711.209a1,1,0,0,1-1-1V290.9248a1,1,0,0,1,2,0V710.209A1,1,0,0,1,330.5411,711.209Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.5411,371.87061a.99683.99683,0,0,1-.70715-.293l-48.13453-48.13428a1,1,0,1,1,1.41431-1.41406l48.13452,48.13427a1,1,0,0,1-.70715,1.707Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.5411,455.20068a1,1,0,0,1-.70715-1.707l80.61-80.61035a1,1,0,1,1,1.41431,1.41406l-80.61,80.61035A.997.997,0,0,1,330.5411,455.20068Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M440.65585,497.082c0-48.26367,39.15191-162.791,87.44824-162.791s87.44824,114.5273,87.44824,162.791a87.44826,87.44826,0,0,1-174.89648,0Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M528.10406,709.68972a.7188.7188,0,0,1-.71906-.71858V407.68224a.71907.71907,0,0,1,1.43813,0v301.2889A.71881.71881,0,0,1,528.10406,709.68972Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M528.10406,465.84821a.71709.71709,0,0,1-.50849-.21052l-34.61187-34.5883a.71881.71881,0,0,1,1.017-1.01611l34.61187,34.58829a.71858.71858,0,0,1-.50849,1.22664Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M528.10406,525.72747a.71858.71858,0,0,1-.50849-1.22664l57.96386-57.92492a.71881.71881,0,0,1,1.017,1.01612l-57.96386,57.92492A.71717.71717,0,0,1,528.10406,525.72747Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M533.3236,703.92751a7.08161,7.08161,0,0,1-6.10072-10.663V693.264l9.91474-16.92759,12.22566,7.16079-9.91474,16.92813A7.08906,7.08906,0,0,1,533.3236,703.92751Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3aaa35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 363.30366,
    cy: 467.72926,
    r: 8.71897,
    fill: "#3aaa35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M494.96231,703.92751a7.08164,7.08164,0,0,1-6.10072-10.6635l9.91474-16.92759,12.2254,7.16079L501.087,700.42534A7.08977,7.08977,0,0,1,494.96231,703.92751Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3aaa35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M552.04672,692.61317H508.115a22.57591,22.57591,0,0,1-22.55044-22.55043v-6.67387a7.84026,7.84026,0,0,1,7.83105-7.83132h58.6511a18.52781,18.52781,0,0,1,0,37.05562Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M549.96489,709.69244a7.0922,7.0922,0,0,1-7.08416-7.08417V682.99059h14.16832v19.61768A7.0922,7.0922,0,0,1,549.96489,709.69244Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M508.85232,709.69244a7.09221,7.09221,0,0,1-7.08417-7.08417V682.99059h14.16833v19.61768A7.0922,7.0922,0,0,1,508.85232,709.69244Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M472.62317,642.83676l-13.59586,10.91946-14.33178-17.84456a8.719,8.719,0,0,1,13.59585-10.91946Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3aaa35"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M491.84959,668.98355l-22.4864,18.05985a6.29433,6.29433,0,0,1-8.83882-.96477l-9.45956-11.77812a20.04438,20.04438,0,0,1,3.07295-28.14757l3.58733-2.88115a16.81161,16.81161,0,0,1,23.60781,2.57732l11.48162,14.29582A6.29411,6.29411,0,0,1,491.84959,668.98355Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M472.62317,642.83676l-9.34715,7.50713-16.038-19.96891a5.99429,5.99429,0,0,1,9.34715-7.50713Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M490.48016,669.84245,465.83768,689.634a8.719,8.719,0,0,1-10.91946-13.59586l24.64249-19.79151Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 454.11833,
    cy: 687.6619,
    rx: 2.04351,
    ry: 3.67832,
    transform: "translate(-539.47859 247.08507) rotate(-38.76955)",
    fill: "#3aaa35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M386.49493,698.1296a10.5,10.5,0,0,1-10.5,10.5c-5.799,0-6-5.25-1.5-10.5-4.5-3-4.299-10.5,1.5-10.5A10.5,10.5,0,0,1,386.49493,698.1296Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M416.49493,698.1296a10.5,10.5,0,0,0,10.5,10.5c5.799,0,6-5.25,1.5-10.5,4.5-3,4.299-10.5-1.5-10.5A10.5,10.5,0,0,0,416.49493,698.1296Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171.56752,
    y: 504.08858,
    width: 42,
    height: 10.5,
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M990.0726,710.6296h-746a1,1,0,1,1,0-2h746a1,1,0,0,1,0,2Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 604.47113,
    cy: 308.67975,
    r: 14.7999,
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M812.442,580.44036a6.62955,6.62955,0,0,1,5.01495-8.52728,6.3076,6.3076,0,0,1,.87929-.10827l15.58961-25.021-14.24028-13.538a5.68355,5.68355,0,1,1,7.90617-8.16656l19.6617,19.38719.03957.04825a5.14883,5.14883,0,0,1-.35822,6.137L825.09141,576.486a6.208,6.208,0,0,1,.1627.63024,6.62992,6.62992,0,0,1-5.95044,7.90352q-.28224.0247-.56168.02471A6.65045,6.65045,0,0,1,812.442,580.44036Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "580.096 514.657 572.708 514.657 569.194 486.162 580.097 486.163 580.096 514.657",
    fill: "#a0616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M791.20823,710.91086,766.7855,710.91v-.60258a9.57264,9.57264,0,0,1,9.57281-9.57267l14.85036.00059Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "653.523 504.443 647.175 508.223 629.577 485.538 638.946 479.96 653.523 504.443",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M847.161,711.02266l-.30835-.51783a9.57315,9.57315,0,0,1,3.32756-13.12281l12.76-7.59723,5.20546,8.74324Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M777.18952,690.89956c-4.94889-58.27279-7.89292-112.40757,10.198-134.491l.1399-.17124L817.973,568.4159l.05017.10887c.10268.22361,10.22805,22.496,7.86615,37.47684l7.5097,34.54457,24.48614,40.99991a2.71242,2.71242,0,0,1-1.23576,3.87321l-10.641,4.68173a2.7245,2.7245,0,0,1-3.40362-1.06392l-26.63635-43.43376-15.045-33.31412a.904.904,0,0,0-1.7227.27658L790.86106,690.959a2.70665,2.70665,0,0,1-2.69629,2.425h-8.27233A2.72994,2.72994,0,0,1,777.18952,690.89956Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M787.49011,556.87044l-.14506-.06943-.02265-.15948c-1.13733-7.96.2089-16.80446,4.001-26.28739a20.871,20.871,0,0,1,24.22472-12.49934h0a20.84575,20.84575,0,0,1,13.29317,10.222,20.62071,20.62071,0,0,1,1.42979,16.52554c-4.78074,13.97989-10.98245,27.06-11.04454,27.19068l-.1299.273Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#3aaa35"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M765.583,589.88307a6.76854,6.76854,0,0,1,4.85295-7.38255l28.46991-54.658a5.45461,5.45461,0,1,1,9.2827,5.73051L779.046,587.85045a6.569,6.569,0,0,1,.10826,1.0002,6.81343,6.81343,0,0,1-6.90477,6.997h0a6.81974,6.81974,0,0,1-5.22862-2.561A6.73612,6.73612,0,0,1,765.583,589.88307Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#a0616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M795.45409,489.11061h23.50048v-10.2438c-5.15809-2.04922-10.20555-3.792-13.25668,0a10.24386,10.24386,0,0,0-10.2438,10.24379Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M820.25564,477.05908c14.049,0,17.98138,17.60991,17.98138,27.54455,0,5.54044-2.50564,7.52206-6.443,8.19256l-1.39052-7.416-3.25679,7.73515c-1.106.00551-2.2679-.01589-3.47247-.03825L822.57,510.80336l-2.46238,2.23292c-9.86219.01468-17.83309,1.4523-17.83309-8.43265C802.27456,494.669,805.72319,477.05908,820.25564,477.05908Z",
    transform: "translate(-208.9274 -188.79102)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about_us.d53f446af0a91e7464ddf2e2383032a9.svg";
export { ForwardRef as ReactComponent };